import {
    APIResponse,
    DeclineForm,
    EnumUserRole,
    GetEnumSortDataDto,
    OrderDto,
    OrderPaymentDetailsDto,
    OrderPriceDetail,
    OrderPriceDetailDto,
    OrderStatus,
    OrderSubStatus,
    OrderVehicleDto,
    SortConfigurationDto,
    SortOptionDto,
} from "@/shared/api-contract/api-contract";
import { useI18n } from "@/shared/composables/use-i18n";
import format from "date-fns/format";
import { setup } from "vue-class-component";
import { isNil } from "lodash";
import { Model, Options, Prop, Vue } from "vue-property-decorator";
import DocumentsPopup from "@/dashboard/my-orders/popup/documents-popup/documents-popup.vue";
import { formatDistanceToNowStrict } from "date-fns";
import { currentUserModel } from "@/shared/state/current-user.model";
import { appCompanyStatusDialogModel } from "@/shared/components/app-company-status-dialog/app-company-status-dialog.model";
import { eff } from "@/core/utils/effect-ts-abbr";
import "./table-item.scss";
import { reactive, watch } from "vue";
import { appAxios } from "@/core/utils/appAxios";
import env, { getEnvValue } from "@/shared/models/environment";
import RefOrdersComponent from "./ref-orders.vue";
import DeclinePopup from "@/dashboard/my-orders/new-popup/decline-popup/decline-popup.vue";
import OrderVehicleTable from "@/dashboard/my-orders/orders-table/table-item/order-vehicle-table.vue";
import { routerModel } from "@/router/router.model";
import ConfirmDatePopup from "@/dashboard/my-orders/new-popup/confirm-date-popup/confirm-date-popup.vue";
import Calendar from "primevue/calendar";
import PaymentsTransactionsPopup from "@/dashboard/my-orders/new-popup/payments-transactions-popup/payments-transactions-popup.vue";
import PaymentPopup from "@/dashboard/my-orders/new-popup/payment-popup/payment-popup.vue";
import UploadCmrPopup from "@/dashboard/my-orders/new-popup/upload-cmr-popup/upload-cmr-popup.vue";
import SortBlockComponent from "@/shared/vehicles/search-bar/sort-block/sort-block.vue";
import { useIsTablet } from "@/shared/composables/use-is-tablet";
import ManualTransferPopup from "@/dashboard/my-orders/new-popup/manual-transfer-popup/manual-transfer-popup.vue";

export const DAY_IN_MILLS = 86400000;

const maxDate = new Date();
maxDate.setMonth(12);
maxDate.setFullYear(new Date().getFullYear() + 2);

const d1 = new Date(new Date().getFullYear(), 7, 30);
const d2 = new Date(new Date().getFullYear() + 1, 7, 30);
const d3 = new Date(new Date().getFullYear(), 7, 31);
const d4 = new Date(new Date().getFullYear() + 1, 7, 31);

const BRAND_NO_IMAGE_CLASS_MAP = {
    astara: "astara",
};

@Options({
    components: {
        "documents-popup": DocumentsPopup,
        "upload-cmr-popup": UploadCmrPopup,
        "payment-popup": PaymentPopup,
        "app-ref-orders": RefOrdersComponent,
        "order-vehicle-table": OrderVehicleTable,
        "manual-transfer-popup": ManualTransferPopup,
        DeclinePopup,
        ConfirmDatePopup,
        PaymentsTransactionsPopup,
        "p-calendar": Calendar,
        SortBlock: SortBlockComponent,
    },
})
export class TableItem extends Vue {
    @Model("_selectedOrders", { required: true })
    selectedOrders!: Array<OrderDto>;
    @Model("_selectedCars", { required: false })
    selectedCars!: Array<OrderVehicleDto>;
    @Model("_declineOrderIds", { required: true })
    declineOrderIds!: number[];
    @Model("_approveOrders", { required: true })
    approveOrders!: OrderDto[];
    @Model("_updateData", { required: true })
    updateData!: boolean;
    @Model("_orderId", { required: true })
    orderId!: number;
    @Model("_orderPaymentDto", { required: true })
    orderPaymentDto!: OrderPaymentDetailsDto;
    @Model("_sortModel", { required: true })
    sortModelConfig!: SortConfigurationDto;
    @Model("_isPaymentsTransactionsPopup", { required: true })
    isPaymentsTransactionsPopup!: boolean;
    @Model("_viewProformaOrder", { required: true })
    viewProformaOrder!: OrderDto;
    @Prop({ required: true })
    order!: OrderDto;
    @Prop({ required: true })
    orderStatus!: OrderStatus;
    // isUserAgreedTerms = false;

    @Prop()
    fetchOrders!: () => void;

    orderStatusClass: Record<OrderStatus, string> = {
        [OrderStatus.to_approve]: "dashboard__table--approve",
        [OrderStatus.to_transport]: "dashboard__table--deliver",
        [OrderStatus.on_order]: "dashboard__table--progress",
        [OrderStatus.to_pay]: "dashboard__table--pay",
        [OrderStatus.processing_documents]: "dashboard__table--waiting",
        [OrderStatus.completed]: "dashboard__table--completed",
    };
    i18n = setup(useI18n);
    orderStatusEnum = OrderStatus;
    orderSubStatusEnum = OrderSubStatus;
    isLoading = false;
    // showApprove = false;
    showDatePicker = true;
    isEye = false;
    selectedDates: Date[] = [];
    // showDecline = false;
    showPay = false;
    // showManual = false;
    @Prop({ default: false })
    showDocuments!: boolean;
    showUploadCmr = false;
    pfnrValue = "";
    pickupDate = null;
    maxDate = maxDate;
    disabledDates = [d1, d2, d3, d4];
    disabledDays = [0, 6];
    orderPriceDetailDto: OrderPriceDetailDto | null = null;
    orderVehicles: OrderVehicleDto[] = [];
    // filteredPayAwaitingPayment: OrderVehicleDto[] = [];
    // filteredPayProcessingPayment: OrderVehicleDto[] = [];
    // amountPaidConfirmed = 0;
    trackLoadCount = 0;
    trackCount = 0;
    showConfirmPopup = false;
    // isPopupOpen = false;
    isTabletCtx = setup(useIsTablet);
    sortModel: SortConfigurationDto = {
        id_direction: 1,
        id_field: 2,
    };
    sortOptions = [] as readonly SortOptionDto[];
    isManualTransferSelected = false;

    async mounted() {
        await this.fetchOrderPaymentDto(this.order.id);
        await this.fetchOrderPriceDetailDto();
        if (this.isOrderInStatus(OrderStatus.to_approve) && !this.isFinalizingOrder) {
            this.initializeTimer();
        }
        watch(
            () => ({
                params: {
                    sort_field: this.sortModelConfig?.id_field,
                    sort_direction: this.sortModelConfig?.id_direction,
                },
            }),
            async ({ params }) => {
                if (
                    this.sortModelConfig?.id_field &&
                    this.sortModelConfig?.id_direction
                ) {
                    params.sort_direction = this.sortModelConfig?.id_direction;
                    params.sort_field = this.sortModelConfig?.id_field;
                } else {
                    params.sort_direction = this.sortModel?.id_direction;
                    params.sort_field = this.sortModel?.id_field;
                }
                await this.fetchOrderVehicles(params);
            },
            { immediate: true },
        );
        watch(
            () => this.pickupDate,
            async (pickupDate) => {
                if (pickupDate) {
                    const pd = (pickupDate as Date).getTime();
                    await this.savePickupDate(pd);
                }
            },
        );

        if (this.order && this.order.id) {
            appAxios.value
                .head(`/client/web/orders/${this.order.id}/proforma-document`)
                .then((response) => {
                    if (response.status === 200) {
                        this.isEye = true;
                    }
                })
                .catch((res) => {
                    this.isEye = false;
                });
        } else {
            console.error("Order or order.id is undefined");
        }
    }
    async openPaymentsTransactionsPopup(id: number) {
        await this.fetchOrderPaymentDto(id);
        this.orderPaymentDto.payments.sort((a, b) => b.date - a.date);
        this.orderId = id;
        this.isPaymentsTransactionsPopup = true;
    }
    openDecline(id) {
        this.declineOrderIds.push(Number(id));
    }

    closeConfirmPopup(params) {
        const { isSuccess } = params ?? {};
        this.showConfirmPopup = false;
        if (this.fetchOrders && isSuccess) {
            this.fetchOrders();
        }
    }
    getDatePicker() {
        this.showDatePicker = true;
        if (this.$refs.fileInput instanceof HTMLElement) {
            this.$refs.fileInput.click();
        }
    }

    formatDate(_date?: number | bigint, formatString: string = "dd/MM/yyyy"): string {
        if (!_date) return "DD/MM/YYYY";
        const millisecondsSinceEpoch = Number(_date) * 24 * 60 * 60 * 1000;
        const date = new Date(millisecondsSinceEpoch);
        return format(new Date(Number(date)), formatString);
    }

    formatTime(_date?: number | bigint): string {
        if (!_date) return "HH:MM";
        return format(new Date(Number(_date)), "HH:MM");
    }

    distanceFromNow(_date?: number): string {
        if (!_date) return "";
        return formatDistanceToNowStrict(_date);
    }

    showCompanyStatusDialog(
        type: "default" | "order-approve" | "order-decline" = "default",
    ): boolean {
        return appCompanyStatusDialogModel.show(type);
    }

    approveOrder(order: OrderDto) {
        this.approveOrders.push(order);
    }

    selectCar(e) {
        if (this.isFinalizingOrder) {
            return;
        }
        this.selectedOrders = eff.fn.pipe(
            this.selectedOrders,
            eff.array.filter((data) => data?.id !== this.order?.id),
            eff.array.toMutable,
        );
        if (e.target?.checked) {
            this.selectedOrders = [...this.selectedOrders, this.order];
        }
    }

    get canApprove() {
        return (
            currentUserModel.userDto.value !== undefined &&
            currentUserModel.userDto.value?.role.id >= EnumUserRole.PURCHASOR
        );
    }

    get isSelected() {
        return eff.fn.pipe(
            this.selectedOrders,
            eff.array.findFirst((_order) => _order?.id === this.order?.id),
            eff.option.isSome,
        );
    }

    get showCheckbox() {
        return [
            String("to_approve"),
            String("to_pay"),
            String("to_transport"),
            "1",
            "3",
            "4",
        ].includes(this.orderStatus);
    }

    get totalPrice() {
        if (isNil(this.order)) return "";

        return this.order.total_amount_euro_excl_vat;
    }

    getTrackLoadCount() {
        let trackLoadCount = this.orderPriceDetailDto?.total_transport_units;
        this.trackLoadCount = trackLoadCount == undefined ? 0 : trackLoadCount;
        this.trackCount = Math.ceil(this.trackLoadCount / 7);
        return this.trackLoadCount / 7;
    }
    getTrackLoadPercent() {
        const count = this.getTrackLoadCount() * 100;
        return `${count}%`;
    }

    // getPlanningOngoingCount() {
    //     return 0
    //     // this.counters.planningOnGoing = this.orderVehicles.filter((e) => e.status.id === 10).length;
    // }

    // getTransportPlannedCount() {
    //     return 0
    //     // return this.orderVehicles.filter((e) => e.status.id === 11).length;
    // }

    // getTransportAwaitingPickupDateCount() {
    //     return 0
    //     // return this.orderVehicles.filter((e) => e.status.id === 8).length;
    // }

    // getTransportReadyForPickupCount() {
    //     return 0
    //     // return this.orderVehicles.filter((e) => e.status.id === 9).length;
    // }

    // getAllPayProcessingPayment() {
    //     return 0
    //     // return this.orderVehicles.filter((e) => e.status.id !== 7).length > 0;
    // }
    // getPayAwaitingPaymentCount() {
    //     return 0
    //     // this.filteredPayAwaitingPayment = this.orderVehicles.filter(
    //     //     (e) => e.status.id === 4 || e.status.id === 6,
    //     // );
    //     // return this.filteredPayAwaitingPayment.length;
    // }
    // getPayProcessingPaymentCount() {
    //     return 0
    //     // this.filteredPayProcessingPayment = this.orderVehicles.filter(
    //     //     (e) => e.status.id === 5 || e.status.id === 7,
    //     // );
    //     // return this.filteredPayProcessingPayment.length;
    // }
    counters = reactive({
        planningOnGoing: 0,
        transportPlanned: 0,
        transportAwaitingPickupDate: 0,
        transportReadyForPickup: 0,
        allPayProcessingPayment: 0,
        filteredPayAwaitingPayment: 0,
        filteredPayProcessingPayment: 0,
        processingDocInfo: 0,
    });
    updateCounters() {
        const counters = {
            planningOnGoing: 0,
            transportPlanned: 0,
            transportAwaitingPickupDate: 0,
            transportReadyForPickup: 0,
            allPayProcessingPayment: 0,
            filteredPayAwaitingPayment: 0,
            filteredPayProcessingPayment: 0,
            processingDocInfo: 0,
        };
        const vehicles = this.orderVehicles;
        vehicles.forEach((vehicle) => {
            const { id } = vehicle.status;
            if (id !== 8) counters.allPayProcessingPayment += 1;
            switch (id) {
                case 5:
                case 7:
                    counters.filteredPayAwaitingPayment += 1;
                    break;
                case 6:
                case 8:
                    counters.filteredPayProcessingPayment += 1;
                    break;
                case 9:
                    counters.transportAwaitingPickupDate += 1;
                    break;
                case 10:
                    counters.transportReadyForPickup += 1;
                    break;
                case 11:
                    counters.planningOnGoing += 1;
                    break;
                case 12:
                    counters.transportPlanned += 1;
                    break;
                case 13:
                    counters.processingDocInfo += 1;
                    break;
                case 14:
                    counters.processingDocInfo += 1;
                    break;
                default:
                    break;
            }
        });

        this.counters = { ...counters };
    }

    // get openPayButton() {
    //     return (
    //         // this.counters.allPayProcessingPayment > 0 ||
    //         this.counters.filteredPayAwaitingPayment > 0
    //         // this.counters.filteredPayProcessingPayment > 0
    //     );
    // }

    get openTransportPlanningInfo() {
        return this.counters.planningOnGoing > 0 || this.counters.transportPlanned > 0;
    }

    get openPickupDateReadyForPickupInfo() {
        return (
            this.counters.transportAwaitingPickupDate > 0 ||
            this.counters.transportReadyForPickup > 0
        );
    }
    get openPickupDateButton() {
        return this.counters.transportAwaitingPickupDate > 0;
    }

    get openProcessingDocInfo() {
        return this.counters.processingDocInfo > 0;
    }

    get formattedSelectedDate() {
        this.showDatePicker = false;
        return new Date(this.selectedDates[0]);
    }
    handleDateSelected(value) {
        this.selectedDates = value;
        this.showDatePicker = false;
        this.showConfirmPopup = true;
    }
    get isFinalizingOrder() {
        return false;
    }

    isOrderInStatus(_status: OrderStatus) {
        return this.order?.status.id.toString() === _status;
    }

    isSortBlock(status: string) {
        return (
            ["1", "2", "3", "4", "5", "6"].includes(status) &&
            !this.isTabletCtx.isTablet.matches
        );
    }
    isOrderInSubStatus(_subStatus: OrderSubStatus) {
        // return this.order?.subStatus === _subStatus;
        return false;
    }

    get allowedCheckbox() {
        return (
            this.canApprove &&
            (this.orderStatus === OrderStatus.on_order ||
                this.orderStatus === OrderStatus.to_approve)
        );
    }

    async savePickupDate(pickupDate: number) {
        await appAxios.value.post(
            `${env.FILE_MAKER_API}web/orders/${this.order.id}/pickup-date`,
            {
                pickupDate,
            },
        );
    }
    redirectToOrderDetailsAvailable(orderStatus) {
        routerModel.router.push({
            path: `/auth/my-carconnex/my-orders/${orderStatus}/order-details/${this.order.id}`,
        });
    }

    async redirectToOrderDetails() {
        await routerModel.router.push({
            path: `/auth/my-carconnex/my-orders/${this.$route.params.order_status}/order-details/${this.order.id}`,
        });
    }
    initializeTimer() {
        // const endDate = this.order?.created_at + DAY_IN_MILLS;

        const currentDate = new Date().getTime();
        let seconds = (Date.now() - currentDate) / 1000;

        if (seconds > 0) {
            let minutes = seconds / 60;
            let hours = minutes / 60;

            minutes = (hours - Math.floor(hours)) * 60;
            hours = Math.floor(hours) - 24;
            seconds = Math.floor((minutes - Math.floor(minutes)) * 60);
            minutes = Math.floor(minutes);

            this.setTimePage(hours, minutes, seconds);

            const secOut = () => {
                if (seconds === 0) {
                    if (minutes === 0) {
                        if (hours === 0) {
                            hours = 0;
                            minutes = 0;
                            seconds = 0;
                        } else {
                            hours--;
                            minutes = 59;
                            seconds = 59;
                        }
                    } else {
                        minutes--;
                        seconds = 59;
                    }
                } else {
                    seconds--;
                }
                this.setTimePage(hours, minutes, seconds);
            };
            setInterval(secOut, 1000);
        } else {
            this.setTimePage(0, 0, 0);
        }
    }

    setTimePage(h, m, s) {
        const hours = document.getElementById(`hours${this.order.id}`);
        const minutes = document.getElementById(`minutes${this.order.id}`);
        const seconds = document.getElementById(`seconds${this.order.id}`);

        if (hours) hours.innerHTML = h.toString().length === 1 ? `0${h}` : h;
        if (minutes) minutes.innerHTML = m.toString().length === 1 ? `0${m}` : m;
        if (seconds) seconds.innerHTML = s.toString().length === 1 ? `0${s}` : s;
    }

    dateOf(value?: string) {
        if (!value) return "";
        try {
            const formattedDate = this.formatDate(parseInt(value));
            if (formattedDate !== "DD/MM/YYYY") return formattedDate;
        } catch (e) {
            return value;
        }
        return value;
    }

    isTBD(priceDetail: OrderPriceDetail) {
        if (isNil(priceDetail?.price)) {
            return true;
        }

        return priceDetail?.price?.toString().toUpperCase() === "TBD";
    }

    getOrderStatusId() {
        if (this.orderStatus === String("to_approve") || this.orderStatus == "1") {
            return 1;
        } else if (this.orderStatus === String("on_order") || this.orderStatus == "2") {
            return 2;
        } else if (this.orderStatus === String("to_pay") || this.orderStatus == "3") {
            return 3;
        } else if (
            this.orderStatus === String("to_transport") ||
            this.orderStatus == "4"
        ) {
            return 4;
        } else if (
            this.orderStatus === String("processing_documents") ||
            this.orderStatus == "5"
        ) {
            return 5;
        } else {
            return 6;
        }
    }
    public updateOrders() {
        const params = {
            sort_field: this.sortModelConfig?.id_field,
            sort_direction: this.sortModelConfig?.id_direction,
        };
        this.fetchOrderVehicles(params);
    }
    /* API Connectivity --------------------------------------------------------------------------------------------- */
    async fetchOrderVehicles(params: Record<string, unknown>) {
        let orderId = this.getOrderStatusId();
        await appAxios.value
            .get<APIResponse<OrderVehicleDto[]>>(
                `/client/web/orders/${this.order.id}/status/${orderId}/vehicles?per_page=12&sort_field=${params.sort_field}&sort_direction=${params.sort_direction}`,
            )
            .then((response) => {
                if (response.data.status.code === 200) {
                    this.orderVehicles = response.data.data;
                    this.updateCounters();
                }
            })
            .catch(console.log);
    }

    async fetchOrderPriceDetailDto() {
        let orderId = this.getOrderStatusId();
        await appAxios.value
            .get<APIResponse<OrderPriceDetailDto>>(
                `/client/web/orders/${this.order.id}/status/${orderId}/price-detail`,
            )
            .then((response) => {
                if (response.data.status.code === 200) {
                    this.orderPriceDetailDto = response.data.data;
                }
            })
            .catch(console.log);
    }

    closeUploadCmr() {
        this.showUploadCmr = false;
    }
    get openPayAllButton() {
        return (
            this.showDocuments &&
            this.orderVehicles.some(
                (vehicle) =>
                    vehicle.status.id === 5 ||
                    vehicle.status.id === 7 ||
                    vehicle.status.id === 8,
            )
        );
    }

    get everyVeInProcessingPayments() {
        return this.orderVehicles.every((veh) => veh.status.id === 8);
    }
    get vehicleIds() {
        return this.orderVehicles
            .filter((vehicle) => this.isAvailableForSelection(vehicle))
            .map((vehicle) => {
                if (!this.carIsAlreadySelected(vehicle)) {
                    this.selectedCars.push(vehicle);
                }
                return vehicle.id;
            });
    }
    isAvailableForSelection(orderVehicle: OrderVehicleDto) {
        const statusId = Number(orderVehicle.status.id);
        return (
            statusId === 5 ||
            statusId === 7 ||
            statusId === 9 ||
            statusId === 13 ||
            statusId === 14 ||
            statusId === 10
        );
    }
    carIsAlreadySelected(vehicle: OrderVehicleDto) {
        return this.selectedCars?.some((car) => car.id === vehicle.id);
    }
    showPayAllPopup() {
        this.showPay = true;
    }

    closeManualTransfer() {
        this.isManualTransferSelected = false;
    }

    async fetchOrderPaymentDto(id) {
        if (this.orderStatus !== String("to_pay") && this.orderStatus !== "3") return;
        await appAxios.value
            .get<APIResponse<OrderPaymentDetailsDto>>(`/client/web/orders/${id}/payments`)
            .then((response) => {
                if (response.data.status.code === 200) {
                    this.orderPaymentDto = response.data.data;
                }
            });
    }

    get brandLabel() {
        return getEnvValue("BRAND_LABEL");
    }

    get noImageBlockClassName() {
        return BRAND_NO_IMAGE_CLASS_MAP[this.brandLabel];
    }
}
